<template>
  <div
    class="reporting-sidenav collapse navbar-collapse w-auto"
    :class="{ 'is-dark': $store.state.darkMode }"
    id="sidenav-collapse-main"
  >
    <div class="rs-filters">
      <div class="rs-field">
        <h6 class="rs-label">Date range</h6>
        <DatePickerComponent @date-selected="updateDate" :dates="$store.state.activeReportingDates" :min-date="minimumDate" :key="reportingDatepickerKey"/>
      </div>
      <div class="rs-field rs-timezone">
        <h6 class="rs-label">Timezone</h6>
        <TimeZonePicker @timezone-selected="updateTZ"></TimeZonePicker>
      </div>
    </div>

    <div class="rs-divided rs-summary" v-if="canOpenSummary">
      <router-link
        :to="summaryTo"
        class="rs-heading"
        :class="{ 'is-current': summaryIsActive }"
      >Campaign summary</router-link>
    </div>

    <div
      class="rs-divided rs-nav"
      v-if="hasCreatives"
      :key="creativeNavListKey"
    >
      <h6 class="rs-heading">Creatives</h6>
      <ul class="rs-creatives">
        <li v-for="creative in filteredCreatives" :key="creative.id">
          <router-link
            :to="creativeTo(creative)"
            class="rs-creative"
            :class="{ 'is-current': creativeIsActive(creative) }"
          >{{ creative.name }}</router-link>
        </li>
      </ul>
    </div>

    <div class="rs-divided rs-export">
      <h6 class="rs-heading">Export reporting</h6>
      <label for="Report-download" class="rs-field-label">Download data</label>
      <UIDropdown name="Report-download" id="Report-download" :modelValue="dlReportFormat" @input="updateReportType" :values="dlReportFormats" />
      <div class="rs-switch-row">
        <label for="with-video" class="rs-field-label">Include Video Quartiles</label>
        <UISwitch id="with-video" name="with-video" :checked="withVideo" :disabled="dlReportFormat=='PDF'" @input="updateWithVideo"></UISwitch>
      </div>
      <UIButton fullWidth class="rs-btn rs-btn-download" @click="reportDownload">
        <i class="fa fa-download" aria-hidden="true"></i>
        Download
      </UIButton>
      <div v-if="!$route.params.shareToken" class="rs-share">
        <label for="Share-Report" class="rs-field-label">Share link</label>
        <UIInput type="url" id="Share-Report" :modelValue="$store.state.activeReporting.reportURL" name="Share-Report" placeholder="—" :readonly="true" :key="$store.state.activeReporting.reportURL"/>
        <UIButton fullWidth class="rs-btn rs-btn-generate" @click="getShareURL">Generate URL</UIButton>
        <UIButton fullWidth class="rs-btn rs-btn-schedule" @click="openScheduleModal">
          <i class="ni ni-calendar-grid-58" aria-hidden="true"></i>
          Schedule reporting
        </UIButton>
      </div>
    </div>
  </div>
</template>
<script>
import UIInput from "@/components/UIInput.vue";
import UIDropdown from "@/components/UIDropdown.vue";
import UISwitch from "@/components/UISwitch.vue";

import UIButton from "@/components/UIButton.vue";
import DatePickerComponent from '@/components/reporting/DatePicker.vue';
import TimeZonePicker from "@/components/reporting/TimeZonePicker.vue";
function downloadURI(uri, name) {
  const link = document.createElement("a");
  link.download = name;
  link.href = uri;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default {
  name: "ReportingSidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "Aderize Admin Dashboard",
      isActive: "active",
      showAdminDrop: false,
      withVideo: this.$store.state.activeReporting && this.$store.state.activeReporting.videoCompletes > 0 || false,
      campaign:this.$route.params.campaignID ? this.$store.getters['campaigns/getByID'](this.$route.params.campaignID) : this.$store.state.activeReporting,
      reportTypes: [
        "Summary",
        "Full"
      ],
      reportFrequencies: [
        "Daily",
        "Weekly",
        "Monthly",
        "On campaign end"
      ],
      dlReportFormats: [
        "PDF",
        "Report CSV",
        "Report Excel",
        "Events CSV",
        "Events Excel"
        //"Excel with Pivot"
      ],
      reportFormats: [
        "CSV",
        "Excel"
      ],
      dlReportFormat: 'Report CSV'
    };
  },
  computed: {
    useDates() {
      let output = [];
      if (!this.$store.state.activeReportingDates) {
        if (this.$store.state.activeReporting && this.$store.state.activeReporting.data) {
          const campaign = this.$store.state.activeReporting;
          output = [
              new Date(campaign.data.start.date),
              campaign.data.end && new Date(campaign.data.end.date) || new Date()
          ];

        }
      }
      return output || this.$store.state.activeReportingDates;
    },
    minimumDate() {
      //const useCampaign = this.campaign || this.$store.state.activeReporting;
      /* if(useCampaign && useCampaign.data && useCampaign.data.start && useCampaign.data.start.date) {
        return new Date(useCampaign.data.start.date);
      } */
      return null;
    },
    reportingDatepickerKey() {
      const d = this.$store.state.activeReportingDates;
      if (!d || !d[0]) return 'daterange';
      const t0 = d[0]?.getTime ? d[0].getTime() : new Date(d[0]).getTime();
      const t1 = d[1]?.getTime ? d[1].getTime() : (d[1] ? new Date(d[1]).getTime() : '');
      return `dr:${t0}:${t1}`;
    },
    creativeNavListKey() {
      const ar = this.$store.state.activeReporting;
      const id = ar?.id ?? 'none';
      const count = Array.isArray(ar?.creatives) ? ar.creatives.length : 0;
      return `nav:${id}:${count}`;
    },
    reportingQuery() {
      const source = this.$route.query || {};
      const query = {};
      if (source.start) query.start = source.start;
      if (source.end) query.end = source.end;
      if (source.tz) query.tz = source.tz;
      return query;
    },
    isBlsRoute() {
      return this.$route.name === 'Campaign BLS reporting' || this.$route.name === 'Share campaign BLS';
    },
    canOpenSummary() {
      return !!(this.$route.params.shareToken || this.$route.params.campaignID || this.$store.state.activeReporting?.id);
    },
    summaryIsActive() {
      const name = this.$route.name;
      return name === 'Campaign reporting' || name === 'Share campaign reporting';
    },
    summaryTo() {
      if (this.$route.params.shareToken) {
        return {
          name: 'Share campaign reporting',
          params: { shareToken: this.$route.params.shareToken },
          query: this.reportingQuery
        };
      }
      return {
        name: 'Campaign reporting',
        params: {
          campaignID: this.$route.params.campaignID || this.$store.state.activeReporting?.id || ''
        },
        query: this.reportingQuery
      };
    },
    hasCreatives() {
      return !!(this.$store.state.activeReporting && this.$store.state.activeReporting.creatives);
    },
    filteredCreatives() {
      const creatives = this.$store.state.activeReporting && this.$store.state.activeReporting.creatives;
      if (!Array.isArray(creatives)) return [];
      return creatives.filter((creative) => creative.liveCreatives && creative.liveCreatives.length > 0);
    }
  },
  components: {
    DatePickerComponent,
    UIInput,
    UISwitch,
    UIDropdown,
    UIButton,
    TimeZonePicker
  },
  methods: {
    creativeTo(creative) {
      if (this.$route.params.shareToken) {
        return {
          name: 'Share creative reporting',
          params: {
            shareToken: this.$route.params.shareToken || '',
            creativeID: this.getCreativeLiveID(creative) || ''
          },
          query: this.reportingQuery
        };
      }
      return {
        name: 'Creative reporting',
        params: {
          campaignID: this.$store.state.activeReporting.id || '',
          creativeID: creative.id || ''
        },
        query: this.reportingQuery
      };
    },
    getCreativeLiveID(creative) {
      let output = creative.id;
      if (creative.liveCreatives && creative.liveCreatives.length > 0) {
        output = creative.liveCreatives[0].id;
        for (let i = 1; i < creative.liveCreatives.length; i++) {
          output += ',' + creative.liveCreatives[i].id;
        }
      }
      return output;
    },
    toUTCTimestamp(dt) {
      if (!dt) return dt;
      if (!dt.getTime) dt = new Date(dt);
      if (!dt) return dt;
      return (dt.getTime() + dt.getTimezoneOffset()*60*1000)/1000;
    },
    openScheduleModal() {
      this.$store.state.showScheduleModal = true;
    },
    creativeIsActive(creative) {
      if (this.$route.name === 'Share creative reporting') {
        return this.$route.params.creativeID === this.getCreativeLiveID(creative);
      }
      if (this.$route.name === 'Creative reporting') {
        return this.$route.params.creativeID === creative.id;
      }
      return false;
    },
    getShareURL() {
      const useCampaign = this.campaign || this.$store.state.activeReporting;
      const that = this;
      this.$store.state.campaigns.loading = true;
      this.$store.getters['campaigns/createNewReportToken']({campaignID: useCampaign.id}).then((response) => {
        this.$store.state.campaigns.loading = false;
        if (response.data && response.data.url) {
          let useURL = response.data.url;
          if (this.isBlsRoute) {
            useURL = String(useURL).replace(/\/$/, '') + '/bls';
          }
          const extras = [];
          if (this.$route.query.start) extras.push('start=' + encodeURIComponent(this.$route.query.start));
          if (this.$route.query.end) extras.push('end=' + encodeURIComponent(this.$route.query.end));
          if (this.$route.query.tz) extras.push('tz=' + encodeURIComponent(this.$route.query.tz));
          if (extras.length) {
            useURL += (useURL.indexOf('?') >= 0 ? '&' : '?') + extras.join('&');
          }
          this.$store.state.activeReporting.reportURL = useURL;
        }
      }).catch((error) => {
            that.$store.state.campaigns.loading = false;

            console.error(error);
            that.$store
                .commit('notifications/ADD_NOTIFICATION', {
                    title: 'Error!',
                    text: 'Couldn\'t receive reporting! Please try again.',
                    type: 'danger',
                    timeout: true,
                    delay: 10000
                });
        })
    },
    updateDate(dates) {
      if (!dates && this.$store.state.activeReportingDates) dates = this.$store.state.activeReportingDates;
      else {
        if (!dates) return;
        if (!this.$store.state.activeReportingDates) this.$store.state.activeReportingDates = [];
        this.$store.state.activeReportingDates[0] = dates[0] && dates[0].getTime ? dates[0] : new Date(dates[0]);
        this.$store.state.activeReportingDates[1] = dates[1] && dates[1].getTime ? dates[1] : new Date(dates[1]);
      }
    },
    updateTZ(tz) {
      if (this.$store.state.activeReportingTimezone && this.$store.state.activeReportingTimezone.offset) {
        Object.assign(this.$store.state.activeReportingTimezone,tz);
      } else {
        this.$store.state.activeReportingTimezone = tz;

      }
    },
    updateReportType(newType) {
      this.dlReportFormat = newType;
    },
    updateWithVideo(newType) {
      this.withVideo = newType;
    },
    getLiveIDs() {
      const useCampaign = this.campaign || this.$store.state.activeReporting;
      let output = [];
      if (useCampaign && useCampaign.creatives) {
        useCampaign.creatives.forEach((creative) => {
          if (creative.liveCreatives && creative.liveCreatives.length > 0) {
            creative.liveCreatives.forEach((liveCreative) => {
              output.push(liveCreative.id);
            })
          } else {
            output.push(creative.id);
          }
        })
      }
      return output;
    },
    reportDownload() {
      if (this.dlReportFormat === 'PDF') {
        window.print(); 
      } else {
        let reportType = 'report';
        let reportFormat = 'csv';
        switch(this.dlReportFormat) {
          case 'Report CSV':
            reportFormat = 'csv';
            reportType = 'report';
            break;
          case 'Report Excel':
            reportFormat = 'xlsx';
            reportType = 'report';
            break;
          case 'Events CSV':
            reportFormat = 'csv';
            reportType = 'events';
            break;
          case 'Events Excel':
            reportFormat = 'xlsx';
            reportType = 'events';
            break;
        }
        const that = this;
        this.$store.state.campaigns.loading = true;
        const useCampaign = this.campaign || this.$store.state.activeReporting;
        let tzOffset = this.$store.state.activeReportingTimezone && this.$store.state.activeReportingTimezone.offset || '+00:00';

        if (!this.$store.state.activeReportingDates || this.$store.state.activeReportingDates[0]) {
          if (!this.$store.state.activeReportingDates) this.$store.state.activeReportingDates = [];
          if (this.$route.query.start) {
            this.$store.state.activeReportingDates[0] = new Date(this.$route.query.start*1000)
          }
          if (this.$route.query.end) {
            this.$store.state.activeReportingDates[1] = new Date(this.$route.query.end*1000)
          }

        }
        let endPoint = 'campaigns/getCampaignDateReport';
        if (this.$route.params.shareToken) {
          endPoint = reportType == 'report' ? 'campaigns/getSharedDateReport' : 'campaigns/getCampaignDateEvents';
        } else {
          endPoint = reportType == 'report' ? 'campaigns/getCampaignDateReport' : 'campaigns/getCampaignDateEvents';
        }
        const useID = this.$route.params.shareToken ? this.$route.params.shareToken : useCampaign.id;
        const liveIDs = this.$route.params.shareToken ? this.getLiveIDs() : null;
        this.$store.getters[endPoint](useID,this.$store.state.activeReportingDates[0],this.$store.state.activeReportingDates[1], tzOffset, reportFormat, this.withVideo, liveIDs).then((report) => {
            const API_URL = process.env.VUE_APP_API_URL
            if(report.file) {
              const fileUrl = API_URL + '/uploads/' + report.file;
              const filename = fileUrl.split('/').pop();
              downloadURI(fileUrl,filename);
            }
            this.$store.state.campaigns.loading = false;

        }).catch((error) => {
            that.$store.state.campaigns.loading = false;

            console.error(error);
            that.$store
                .commit('notifications/ADD_NOTIFICATION', {
                    title: 'Error!',
                    text: 'Couldn\'t receive reporting! Please try again.',
                    type: 'danger',
                    timeout: true,
                    delay: 10000
                });
        })
      }
    }
  },
  mounted() {
    const useCampaign = this.campaign || this.$store.state.activeReporting;
    if (this.$route.query.start) {
      this.$store.state.activeReportingDates[0] = new Date(this.$route.query.start*1000)
    }
    if (this.$route.query.end) {
      this.$store.state.activeReportingDates[1] = new Date(this.$route.query.end*1000)
    }
    if (this.$route.query.tz) {
      if (!this.$store.state.activeReportingTimezone || !(this.$store.state.activeReportingTimezone instanceof Object)) this.$store.state.activeReportingTimezone = {};
      this.$store.state.activeReportingTimezone.offset = this.$route.query.tz;
    }
    if (!this.$store.state.activeReportingDates) {
        if (useCampaign && useCampaign.data) {
          const campaign = useCampaign;
          this.$store.state.activeReportingDates = [
              new Date(campaign.data.start.date),
              campaign.data.end && new Date(campaign.data.end.date) || new Date()
          ];

        }
      }
    document.querySelector('#app').classList.add('g-sidenav-secondary')
  },
  unmounted() {
    document.querySelector('#app').classList.remove('g-sidenav-secondary')
  }
};
</script>

<style scoped>
.reporting-sidenav {
  --rs-line: rgba(23, 23, 23, 0.08);
  --rs-field: #f4f5f7;
  --rs-field-border: #e6e8ee;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  overflow: visible;
  padding: 0.85rem 1rem 1rem;
  box-sizing: border-box;
}

.reporting-sidenav.navbar-collapse {
  height: auto !important;
  max-height: none !important;
  align-self: stretch;
}

.reporting-sidenav.is-dark {
  --rs-line: rgba(255, 255, 255, 0.14);
  --rs-field: rgba(255, 255, 255, 0.08);
  --rs-field-border: rgba(255, 255, 255, 0.18);
}

.reporting-sidenav.is-dark .rs-label,
.reporting-sidenav.is-dark .rs-heading {
  color: #fff;
}

.reporting-sidenav.is-dark .rs-label {
  opacity: 0.72;
}

.rs-field + .rs-field {
  margin-top: 0.95rem;
}

.rs-label,
.rs-heading {
  margin: 0;
  color: inherit;
  line-height: 1.3;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.rs-label {
  margin-bottom: 0.4rem;
  font-size: 0.68rem;
  font-weight: 700;
  opacity: 0.55;
}

.rs-heading {
  display: block;
  margin-bottom: 0.7rem;
  font-size: 0.75rem;
  font-weight: 700;
  text-decoration: none;
  opacity: 0.9;
}

.rs-heading.is-current {
  opacity: 1;
}

.rs-summary .rs-heading {
  margin-bottom: 0;
}

.rs-divided {
  border-top: 1px solid var(--rs-line);
  margin-top: 0.95rem;
  padding-top: 0.8rem;
}

.rs-filters,
.rs-summary,
.rs-nav,
.rs-export {
  flex-shrink: 0;
  width: 100%;
}

.rs-nav {
  display: flex;
  flex-direction: column;
}

.rs-creatives {
  margin: 0;
  padding: 0;
  list-style: none;
  max-height: 28vh;
  overflow-y: auto;
}

.rs-creative {
  display: block;
  padding: 0.22rem 0;
  color: inherit;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.35;
  text-decoration: none;
  overflow-wrap: anywhere;
}

.rs-creative:hover {
  opacity: 0.7;
}

.rs-creative.is-current {
  font-weight: 600;
  opacity: 1;
}

.rs-export {
  flex: 0 0 auto;
}

.rs-field-label {
  display: block;
  margin-bottom: 0.35rem;
  color: inherit;
  font-size: 0.8125rem;
  font-weight: 400;
}

.rs-timezone :deep(.form-control-label) {
  display: none;
}

.reporting-sidenav :deep(.form-group) {
  margin-bottom: 0.7rem;
}

.reporting-sidenav :deep(.form-control),
.reporting-sidenav :deep(.dp__input),
.reporting-sidenav :deep(.input-group-text) {
  background: var(--rs-field);
  border: 1px solid var(--rs-field-border);
  box-shadow: none;
  color: inherit;
  font-size: 0.8125rem;
  min-height: 2.25rem;
}

.reporting-sidenav :deep(.dp__input) {
  border-radius: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 2rem;
  text-overflow: ellipsis;
}

.reporting-sidenav :deep(.dp__clear_icon) {
  color: inherit;
  opacity: 0.55;
}

.reporting-sidenav :deep(.dropdown .input-group) {
  flex-wrap: nowrap;
}

.reporting-sidenav :deep(.dropdown .form-control),
.reporting-sidenav :deep(.dropdown .input-group-text) {
  border-color: var(--rs-field-border);
}

.reporting-sidenav :deep(.dropdown .form-control) {
  border-right-width: 0;
  border-radius: 0.5rem 0 0 0.5rem;
}

.reporting-sidenav :deep(.dropdown .input-group-text) {
  border-left-width: 0;
  border-right-color: var(--rs-field-border);
  border-radius: 0 0.5rem 0.5rem 0;
}

.reporting-sidenav.is-dark :deep(.form-control),
.reporting-sidenav.is-dark :deep(.dp__input),
.reporting-sidenav.is-dark :deep(.input-group-text) {
  color: #fff;
}

.rs-switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin: 0.1rem 0 0.85rem;
}

.rs-switch-row .rs-field-label {
  margin-bottom: 0;
}

.rs-switch-row :deep(.form-switch) {
  display: flex;
  align-items: center;
  margin: 0;
  padding-left: 2.35em;
  min-height: 1.2rem;
}

.rs-switch-row :deep(.form-check-input) {
  margin-top: 0;
  cursor: pointer;
}

.rs-switch-row :deep(.form-check-input:checked) {
  background-color: #e4e6eb;
  border-color: #e4e6eb;
}

.rs-switch-row :deep(.form-check-input:focus) {
  box-shadow: none;
}

.rs-share {
  margin-top: 0.35rem;
}

.rs-btn.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  width: 100%;
  min-height: 2.4rem;
  margin-bottom: 0.65rem;
  border-radius: 0.55rem;
  font-size: 0.875rem;
  font-weight: 600;
  box-shadow: none !important;
  transform: none !important;
}

.rs-btn.btn:hover,
.rs-btn.btn:active,
.rs-btn.btn:focus {
  box-shadow: none !important;
  transform: none !important;
}

.rs-btn.btn i {
  font-size: 0.9rem;
}

.rs-btn-download.btn {
  background: #6d5efc;
  color: #fff;
}

.rs-btn-download.btn:hover,
.rs-btn-download.btn:focus {
  background: #5b4ce8;
  color: #fff;
}

.rs-btn-generate.btn {
  background: #c6e34d;
  color: #1c2410;
}

.rs-btn-generate.btn:hover,
.rs-btn-generate.btn:focus {
  background: #b6d43c;
  color: #1c2410;
}

.rs-btn-schedule.btn {
  margin-top: 0.65rem;
  margin-bottom: 0;
  background: #fff;
  color: #344767;
  border: 1px solid #e1e4ea;
}

.rs-btn-schedule.btn:hover,
.rs-btn-schedule.btn:focus {
  background: #f7f8fa;
  color: #344767;
}

.reporting-sidenav.is-dark .rs-btn-schedule.btn {
  background: transparent;
  color: rgba(255, 255, 255, 0.92);
  border-color: rgba(255, 255, 255, 0.22);
}

.reporting-sidenav.is-dark .rs-btn-schedule.btn:hover,
.reporting-sidenav.is-dark .rs-btn-schedule.btn:focus {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}
</style>
